"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_LOCATIONS_HASH = void 0;
exports.GET_LOCATIONS_HASH = `
  {
    locations
  }
`;
//# sourceMappingURL=locations-queries.js.map